import { ArticleFooter } from "@babackapp/customer-ui/components/article";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@babackapp/customer-ui/components/tooltip";
import { InfoIcon } from "lucide-react";

type Props = {
  /** `getReferenceTransitionParts` output: purchased SKU, then the chosen one. */
  purchased: string;
  exchanged?: string | null;
  /** "Visible only to you" tooltip, for the merchant when customers do not see it. */
  hint?: string;
};

/**
 * SKU footer of a portal article (summary, final screen). Kept in the text
 * column, off the action column. Each SKU stays on one line: a line breaks
 * between "A" and "→ B", never on a SKU's hyphen, unless one SKU alone is
 * wider than the column.
 */
export function ReferenceFooter({ purchased, exchanged, hint }: Props) {
  return (
    <ArticleFooter
      data-slot="article-reference"
      className="col-span-1 flex min-w-0 items-center gap-1.5"
    >
      <span className="min-w-0">
        <span className="inline-block max-w-full break-all">{purchased}</span>
        {exchanged && (
          <>
            {" "}
            <span className="inline-block max-w-full break-all">
              → {exchanged}
            </span>
          </>
        )}
      </span>
      {hint && (
        <Tooltip>
          <TooltipTrigger asChild onClick={(e) => e.stopPropagation()}>
            <InfoIcon className="size-3.5 shrink-0 cursor-help" />
          </TooltipTrigger>
          <TooltipContent>{hint}</TooltipContent>
        </Tooltip>
      )}
    </ArticleFooter>
  );
}
